// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"485":"game","521":"guide","549":"browser","870":"wishlist"}[chunkId] || chunkId) + "." + {"177":"8ba0bd09","485":"bae612f3","521":"5a8ef622","549":"949e7407","870":"9eebd443"}[chunkId] + ".js";
};